import { Checkbox, Col, Progress, Radio, Row, Select, Space } from "antd"
import { GetCityWithSection } from "hooks/returnCityName"
import Locations from "components/Common/Locations"

import React, { useEffect } from "react"
import { useState } from "react"
export const ListEngineer = ({ props, selectEngineer }) => {
  const { lstEngineer } = props

  const [engGrad, setEngGrad] = useState(0)

  const [dataAddress, setDataAddress] = useState({
    sectionId: 0,
    fullAddress: {
      pro: "",
      cit: "",
      sec: "",
      lat: 35.311308,
      lng: 46.991271,
      mainAddress: "",
    },
  })
  const [filterCity, setFilterCity] = useState(false)

  const countLstEng = lstEngineer?.filter(
    d =>
      !d.engIsLeave &&
      !d.inactive &&
      (engGrad === 0 || d.engineerGradeTypeEnum === engGrad) &&
      (filterCity === false || d.idSection === dataAddress.sectionId)
  )?.length

  useEffect(() => {
    const { onGetListEngineer } = props
    onGetListEngineer()
  }, [])

  const handleChange = value => {
    console.log(value)
    selectEngineer(value)
  }
  return (
    <>
      <Row gutter={[8, 16]}>
        <Col>
          <Radio.Group
            onChange={e => setEngGrad(e.target.value)}
            defaultValue={0}
          >
            <Space direction="horizontal">
              <Radio.Button value={0}>
                {engGrad === 0 ? countLstEng : ""} همه
              </Radio.Button>
              <Radio.Button value={1}>
                {engGrad === 1 ? countLstEng : ""}ارشد
              </Radio.Button>
              <Radio.Button value={2}>
                {engGrad === 2 ? countLstEng : ""} پایه 1
              </Radio.Button>
              <Radio.Button value={3}>
                {engGrad === 3 ? countLstEng : ""} پایه 2
              </Radio.Button>
              <Radio.Button value={4}>
                {engGrad === 4 ? lstEngineer?.length : ""} پایه 3
              </Radio.Button>
            </Space>
          </Radio.Group>
        </Col>

          <Col>
            <Checkbox
              onChange={e => {
                setFilterCity(e.target.checked)
              }}
            >
              فیلتر شهر
            </Checkbox>
          </Col>
          {filterCity && (
            <Col className="gutter-row">
              <Locations setDataAddress={setDataAddress} isAccessCity={true} />
            </Col>
          )}
      <Select
        style={{ width: "100%" }}
        showSearch
        placeholder="انتخاب کارشناس"
        onChange={handleChange}
        filterOption={(input, option) =>
          (option.label || "").toLowerCase().includes(input.toLowerCase())
        }
      >
        {lstEngineer
          ?.filter(
            d =>
              !d.engIsLeave &&
              !d.inactive &&
              (engGrad === 0 || d.engineerGradeTypeEnum === engGrad) &&
              (filterCity === false || d.idSection === dataAddress.sectionId)
          )
          ?.map(engineer => (
            <Select.Option
              key={engineer.id}
              value={engineer.id}
              label={
                engineer.fullDescription +
                GetCityWithSection(engineer.idSection)
              }
            >
              <div
                style={{
                  color:
                    engineer.totalQuotaBalance <= 0 ||
                    engineer.fullDescription.indexOf("ندارد") !== -1
                      ? "red"
                      : "green",
                }}
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html:
                      engineer.fullDescription +
                      GetCityWithSection(engineer.idSection),
                  }}
                />
              </div>
            </Select.Option>
          ))}
      </Select>
      </Row>

    </>
  )
}
